module.exports = __webpack_public_path__ + "static/media/bewal-title.4170f96b.jpg";